import QRCode from 'qrcode'

const _makeImage = (dataUrl) => {
    const image = new Image()
    image.src = dataUrl

    return new Promise(resolve => {
        image.onload = () => {
            resolve(image)
        }
    })
}

/**
 * Fit text into a given maxWidth by reducing font-size.
 * If it reaches minFontSize and still doesn't fit, truncate and add "…".
 * Returns { text, font } where font is the string to set on ctx (e.g. "bold 18px Arial")
 */
const fitTextToWidth = (ctx, text, {
    maxWidth,
    fontSize = 22,
    minFontSize = 8,
    fontFamily = 'Arial',
    fontWeight = '', // e.g. 'bold' or ''
}) => {
    const weightPrefix = fontWeight ? `${fontWeight} ` : ''

    // reduce font size until it fits or we hit min
    let size = fontSize
    while (size >= minFontSize) {
        ctx.font = `${weightPrefix}${size}px ${fontFamily}`
        if (ctx.measureText(text).width <= maxWidth) {
            return { text, font: ctx.font }
        }
        size -= 1
    }

    // if still doesn't fit at min size -> truncate with ellipsis
    let truncated = text
    // quick check: if single char with ellipsis still doesn't fit, return empty string
    if (ctx.measureText('…').width > maxWidth) {
        return { text: '', font: `${weightPrefix}${minFontSize}px ${fontFamily}` }
    }

    while (truncated.length > 0) {
        truncated = truncated.slice(0, -1)
        if (ctx.measureText(truncated + '…').width <= maxWidth) {
            ctx.font = `${weightPrefix}${minFontSize}px ${fontFamily}`
            return { text: truncated + '…', font: ctx.font }
        }
    }

    return { text: '', font: `${weightPrefix}${minFontSize}px ${fontFamily}` }
}

const drawLabel = async ({ orderId, basket, type, total, size }) => {
    const LABEL_WIDTH = 230
    const LABEL_HEIGHT = 170
    const MID_X = (LABEL_WIDTH / 2)

    const qrDataUrl = await QRCode.toDataURL(orderId, { width: 200, margin: 3 })
    const qrDataImage = await _makeImage(qrDataUrl)
    const canvas = document.createElement('canvas')

    canvas.width = LABEL_WIDTH
    canvas.height = LABEL_HEIGHT

    const ctx = canvas.getContext('2d')

    ctx.beginPath()
    ctx.rect(0, 0, LABEL_WIDTH, LABEL_HEIGHT)
    ctx.fillStyle = 'white'
    ctx.fill()

    const qrWidth = MID_X
    const qrY = LABEL_HEIGHT - qrWidth

    ctx.drawImage(qrDataImage, 0, qrY, qrWidth, qrWidth)

    ctx.fillStyle = 'black'
    ctx.font = '22px Arial'
    ctx.fillText(orderId, 12, 30)

    ctx.beginPath()
    ctx.fillStyle = 'black'
    ctx.font = 'bold 25px Arial'
    ctx.fillText(`${basket}/${total}`, MID_X, 90)

    if (['GIFTBOX_0700NO', 'GIFTCARD_1800NO', 'BOX_0700NO', 'LPRO_ACCESS_00NO'].includes(type)) {
        const maxWidth = LABEL_WIDTH - MID_X // don't overflow right edge
        const fitted = fitTextToWidth(ctx, `${size}`, {
            maxWidth,
            fontSize: 25,    // starting font size as original
            minFontSize: 8,
            fontFamily: 'Arial',
            fontWeight: 'bold'
        })
        ctx.font = fitted.font
        ctx.fillStyle = 'black'
        ctx.fillText(fitted.text, MID_X, 115)
    }

    const maxWidth = LABEL_WIDTH - 10  // don't overflow right edge
    const fitted = fitTextToWidth(ctx, type, {
        maxWidth,
        fontSize: 22,    // starting font size as original
        minFontSize: 8,
        fontFamily: 'Arial',
        fontWeight: ''   // not bold originally
    })
    ctx.fillStyle = 'black'
    ctx.font = fitted.font
    ctx.fillText(fitted.text, 12, 55)


    return canvas.toDataURL()
}

export default drawLabel